import { useContext } from 'react';

import { Typography, Spacer, Button, Modal } from '@aircall/tractor';
import { useTranslation } from 'react-i18next';

import { NavigationBlockerContext } from '.';

export function NavigationBlockerDialog() {
  const { t } = useTranslation();
  const { navPromptShown, cancelNavigation, confirmNavigation } =
    useContext(NavigationBlockerContext);
  return (
    <Modal.Dialog size='xSmall' show={navPromptShown} onHide={cancelNavigation}>
      <Modal.Body p='m'>
        <Typography variant='body'>{t('app.form.save_bar.warning_modal.description')}</Typography>
      </Modal.Body>
      <Modal.Footer>
        <Spacer direction='horizontal' space='xxs'>
          <Button
            data-test='navigation-blocker-dialog-cancel'
            mode='link'
            onClick={cancelNavigation}
          >
            {t('app.form.save_bar.warning_modal.button.cancel')}
          </Button>
          <Button data-test='navigation-blocker-dialog-confirm' onClick={confirmNavigation}>
            {t('app.form.save_bar.warning_modal.button.discard')}
          </Button>
        </Spacer>
      </Modal.Footer>
    </Modal.Dialog>
  );
}
